import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { objectToSnake } from 'ts-case-convert';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';
import { IRouteReorganizationRequest } from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class RouteReorganizationHttpService extends BaseHttpService {
  private baseURL = `service-infos`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public simulate(serviceInfoId: number, request: IRouteReorganizationRequest) {
    const url = this.routerService.mount(
      `${this.baseURL}/${serviceInfoId}/route-reorganizations/simulate`,
    );
    return this.create(objectToSnake(request), url);
  }

  public apply(serviceInfoId: number, request: IRouteReorganizationRequest) {
    const url = this.routerService.mount(
      `${this.baseURL}/${serviceInfoId}/route-reorganizations/async`,
    );
    return this.createText(objectToSnake(request), url);
  }
}
